import { render, staticRenderFns } from "./salesRanking.vue?vue&type=template&id=2c02d83b&scoped=true"
import script from "./salesRanking.vue?vue&type=script&lang=js"
export * from "./salesRanking.vue?vue&type=script&lang=js"
import style0 from "./salesRanking.vue?vue&type=style&index=0&id=2c02d83b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02d83b",
  null
  
)

export default component.exports